import i18n from "i18next";

const resources = {
  ar: {
    check_button: "تحقق من الأهلية",
    recheck_button: "إعادة التحقق من الأهلية",
    status_eligible: "مؤهل",
    status_non_eligible: "غير مؤهل",
    status_unavailable: "غير متاح",
    success_title: "تم التحقق من الأهلية بنجاح",
    error_title: "فشل التحقق من الأهلية",
    modal_title: "ملء الحقول الناقصة",
    label_nationalId: "رقم الهوية",
    label_firstName: "الاسم الأول",
    label_lastName: "اسم العائلة",
    label_nphiesCode: "رمز نفيس لشركة التأمين",
    label_tpaNphiesCode: "رمز نفيس لإدارة الطرف الثالث",
    placeholder_nphiesCode: "أدخل رمز نفيس لشركة التأمين",
    label_policyNumber: "رقم الوثيقة",
    label_coverageType: "نوع التغطية",
    label_membershipNumber: "رقم العضوية",
    "auth.nameLength": "لا يمكن أن يتجاوز رقم الهوية 100 حرف",
    msg_membershipNumberLength: "لا يمكن أن يتجاوز رقم العضوية 100 حرف",
    label_serviceDate: "تاريخ الخدمة",
    label_birthDate: "تاريخ الميلاد",
    label_identifierType: "نوع المعرف",
    label_gender: "الجنس",
    label_maritalStatus: "الحالة الاجتماعية",
    label_occupation: "المهنة",
    label_lastChecked: "آخر فحص",
    required: "مطلوب",
    title_eligibilityResult: "نتيجة الأهلية",
    tooltip_insurance_missing: "الأهلية غير متاحة لأن معلومات التأمين مفقودة",
    hint_previewOnly: "هذا التحقق من الأهلية للمعاينة فقط ولن يتم حفظه في ملف المريض. بعد إنشاء المريض، يمكنك إعادة التحقق من الأهلية وحفظها.",
    button_close: "إغلاق",
    label_payerName: "اسم الجهة الدافعة",
    label_responseDate: "تاريخ الاستجابة",
    label_payerReferenceNumber: "رقم مرجع الجهة الدافعة",
    label_remarks: "ملاحظات",
    label_errors: "الأخطاء",
    label_policyHolderName: "اسم حامل الوثيقة",
    label_inceptionDate: "تاريخ بدء التأمين",
    label_expiryDate: "تاريخ إنتهاء التأمين",
    label_providerName: "اسم مقدم الخدمة",
    label_requestDate: "تاريخ الطلب",
    patient_updated_successfully: "تم تحديث بيانات المريض بنجاح",
    error_updating_patient: "فشل تحديث بيانات المريض",
    "Coverage is in-force": "التغطية سارية المفعول",
    national_id: "الهوية الوطنية",
    passport: "جواز سفر",
    driver_license: "رخصة قيادة",
    residency: "إقامة",
    iqama: "إقامة",
    OTHER: "أخرى",
    other: "أخرى",
    male: "ذكر",
    female: "أنثى",
    married: "متزوج",
    single: "أعزب",
    divorced: "مطلق",
    separated: "منفصل",
    widowed: "أرمل",
    "Chiropractor": "أخصائي تقويم العمود الفقري",
    "Doctor": "طبيب",
    "Dentist": "طبيب أسنان",
    "Dietitian or Nutritionist": "أخصائي تغذية",
    "Optometrist": "فاحص بصريات",
    "Pharmacist": "صيدلي",
    "Physician": "طبيب",
    "Physician Assistant": "مساعد طبيب",
    "Podiatrist": "طبيب أقدام",
    "Registered Nurse": "ممرض مسجل",
    "Therapist": "معالج",
    "Veterinarian": "طبيب بيطري",
    "Health Technologist or Technician": "تقني صحي أو فني",
    "Other Healthcare Practitioners and Technical Occupation": "ممارسون صحيون ومهن فنية أخرى",
    "Nursing, Psychiatric, or Home Health Aide": "مساعد تمريض أو طب نفسي أو صحة منزلية",
    "Occupational and Physical Therapist Assistant or Aide": "مساعد معالج مهني أو طبيعي",
    "Other Healthcare Support Occupation": "مهن دعم صحي أخرى",
    "Chief Executive": "رئيس تنفيذي",
    "General and Operations Manager": "مدير عام وعمليات",
    "Advertising, Marketing, Promotions, Public Relations, and Sales Manager": "مدير إعلانات، تسويق، ترويج، علاقات عامة، ومبيعات",
    "Operations Specialties Manager (e.g., IT or HR Manager)": "مدير تخصصات العمليات (مثل مدير تقنية المعلومات أو الموارد البشرية)",
    "Construction Manager": "مدير إنشاءات",
    "Engineering Manager": "مدير هندسي",
    "Accountant, Auditor": "محاسب، مدقق حسابات",
    "Business Operations or Financial Specialist": "أخصائي عمليات تجارية أو مالي",
    "Business Owner": "صاحب عمل",
    "Other Business, Executive, Management, Financial Occupation": "مهن أعمال، تنفيذية، إدارية، مالية أخرى",
    "Architect, Surveyor, or Cartographer": "مهندس معماري، مساح، أو رسام خرائط",
    "Engineer": "مهندس",
    "Other Architecture and Engineering Occupation": "مهن هندسة وعمارة أخرى",
    "Postsecondary Teacher (e.g., College Professor)": "مدرس ما بعد الثانوي (مثل أستاذ جامعي)",
    "Primary, Secondary, or Special Education School Teacher": "مدرس مدرسة ابتدائية، ثانوية، أو تربية خاصة",
    "Other Teacher or Instructor": "مدرس أو مدرب آخر",
    "Other Education, Training, and Library Occupation": "مهن تعليم، تدريب، ومكتبات أخرى",
    "Arts, Design, Entertainment, Sports, and Media Occupations": "مهن الفنون، التصميم، الترفيه، الرياضة، والإعلام",
    "Computer Specialist, Mathematical Science": "أخصائي حاسوب، علوم رياضية",
    "Counselor, Social Worker, or Other Community and Social Service Specialist": "مستشار، أخصائي اجتماعي، أو أخصائي خدمة مجتمعية واجتماعية آخر",
    "Lawyer, Judge": "محام، قاض",
    "Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)": "عالم حياة (مثل عالم حيوان، أغذية، تربة، أو أحياء)",
    "Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)": "عالم فيزيائي (مثل فلكي، فيزيائي، كيميائي، هيدرولوجي)",
    "Religious Worker (e.g., Clergy, Director of Religious Activities or Education)": "عامل ديني (مثل رجل دين، مدير أنشطة دينية أو تعليم)",
    "Social Scientist and Related Worker": "عالم اجتماعي وعامل ذو صلة",
    "Other Professional Occupation": "مهن مهنية أخرى",
    "Supervisor of Administrative Support Workers": "مشرف عمال الدعم الإداري",
    "Financial Clerk": "كاتب مالي",
    "Secretary or Administrative Assistant": "سكرتير أو مساعد إداري",
    "Material Recording, Scheduling, and Dispatching Worker": "عامل تسجيل مواد، جدولة، وإرسال",
    "Other Office and Administrative Support Occupation": "مهن مكتبية ودعم إداري أخرى",
    "Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)": "خدمة حماية (مثل إطفاء، ضابط شرطة، ضابط إصلاحية)",
    "Chef or Head Cook": "طاه أو رئيس طهاة",
    "Cook or Food Preparation Worker": "طباخ أو عامل تحضير طعام",
    "Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)": "عامل تقديم طعام ومشروبات",
    "Building and Grounds Cleaning and Maintenance": "تنظيف وصيانة المباني والمرافق",
    "Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)": "عناية شخصية وخدمة (مثل مصفف شعر، مضيف طيران)",
    "Sales Supervisor, Retail Sales": "مشرف مبيعات، مبيعات تجزئة",
    "Retail Sales Worker": "عامل مبيعات تجزئة",
    "Insurance Sales Agent": "وكيل مبيعات تأمين",
    "Sales Representative": "مندوب مبيعات",
    "Real Estate Sales Agent": "وكيل مبيعات عقارات",
    "Other Services Occupation": "مهن خدمات أخرى",
    "Construction and Extraction (e.g., Construction Laborer, Electrician)": "بناء واستخراج (مثل عامل بناء، كهربائي)",
    "Farming, Fishing, and Forestry": "زراعة، صيد، وحراجة",
    "Installation, Maintenance, and Repair": "تركيب، صيانة، وإصلاح",
    "Production Occupations": "مهن الإنتاج",
    "Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation": "زراعة، صيانة، إصلاح، وحرف ماهرة أخرى",
    "Aircraft Pilot or Flight Engineer": "طيار أو مهندس طيران",
    "Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)": "مشغل مركبات (مثل سائق إسعاف، حافلة، تاكسي، أو شاحنة)",
    "Other Transportation Occupation": "مهن نقل أخرى",
    "Military": "عسكري",
    "Homemaker": "ربة منزل",
    "Other Occupation": "مهنة أخرى",
    "Don't Know": "لا أعرف",
    "Not Applicable": "لا ينطبق",
    "validation.nationalId.sa.format": "يجب أن يتكون رقم الهوية من 10 أرقام بالضبط",
    "validation.nationalId.sa.national_id_start": "يجب أن تبدأ الهوية الوطنية السعودية بالرقم 1",
    "validation.nationalId.sa.iqama_start": "يجب أن يبدأ رقم الإقامة بالرقم 2",
    "validation.nationalId.eg.format": "يجب أن يتكون الرقم القومي المصري من 14 رقماً بالضبط",
    "validation.nationalId.eg.invalid": "رقم الهوية الوطنية المصري يحتوي على تاريخ أو قرن غير صالح",
    "visa": "تأشيرة",
    "border_number": "رقم الحدود",
    "displaced_person": "نازح",
    label_nphiesCode_tooltip: "هذا إعداد خاص بشركة التأمين وليس بيانًا خاصًا بالمريض. القيمة المُدخلة هنا تُستخدم لطلب الأهلية هذا فقط ولا تُحفظ في سجل شركة التأمين. لحفظها بشكل دائم، اضبط رمز NPHIES على شركة التأمين (الشركاء ← شركات التأمين).",
    label_policyNumber_tooltip: "رقم الوثيقة المأخوذ من وثيقة تأمين المريض المسجّلة، ويُرسل مع طلب الأهلية هذا. ما يُدخل هنا يخص هذا الطلب فقط — لتغيير القيمة المحفوظة، حدّث سجل تأمين المريض.",
    label_coverageType_tooltip: "نوع التغطية المأخوذ من فئة وثيقة المريض المسجّلة، ويُرسل مع طلب الأهلية هذا. ما يُدخل هنا يخص هذا الطلب فقط — لتغيير القيمة المحفوظة، حدّث سجل تأمين المريض."
  },
  en: {
    check_button: "Check Eligibility",
    recheck_button: "Re-check Eligibility",
    status_eligible: "Eligible",
    status_non_eligible: "Non-Eligible",
    status_unavailable: "Unavailable",
    success_title: "Eligibility Checked Successfully",
    error_title: "Failed to Check Eligibility",
    modal_title: "Fill Missing Fields",
    label_nationalId: "National ID",
    label_firstName: "First Name",
    label_lastName: "Last Name",
    label_nphiesCode: "Insurance company nphies code",
    label_tpaNphiesCode: "TPA nphies code",
    placeholder_nphiesCode: "Enter Insurance company nphies code",
    label_policyNumber: "Policy Number",
    label_coverageType: "Coverage Type",
    label_membershipNumber: "Membership Number",
    "auth.nameLength": "ID cannot exceed 100 characters",
    msg_membershipNumberLength: "Membership number cannot exceed 100 characters",
    label_serviceDate: "Service Date",
    label_birthDate: "Date of Birth",
    label_identifierType: "Identifier Type",
    label_gender: "Gender",
    label_maritalStatus: "Marital Status",
    label_occupation: "Occupation",
    label_lastChecked: "Last Checked",
    required: "Required",
    title_eligibilityResult: "Eligibility Result",
    tooltip_insurance_missing: "Eligibility is unavailable because insurance information is missing",
    hint_previewOnly: "This eligibility check is for preview only and won't be saved to the patient profile. After the patient is created, you can re-check eligibility and save it.",
    button_close: "Close",
    label_payerName: "Payer Name",
    label_responseDate: "Response Date",
    label_payerReferenceNumber: "Payer Reference Number",
    label_remarks: "Remarks",
    label_errors: "Errors",
    label_policyHolderName: "Policy Holder Name",
    label_inceptionDate: "Inception Insurance Date",
    label_expiryDate: "Expiry Insurance Date",
    label_providerName: "Provider Name",
    label_requestDate: "Request Date",
    patient_updated_successfully: "Patient data updated successfully",
    error_updating_patient: "Failed to update patient data",
    "Coverage is in-force": "Coverage is in-force",
    national_id: "National ID",
    passport: "Passport",
    driver_license: "Driver License",
    residency: "Residency",
    iqama: "Residency (Iqama)",
    OTHER: "Other",
    other: "Other",
    male: "Male",
    female: "Female",
    married: "Married",
    single: "Single",
    divorced: "Divorced",
    separated: "Separated",
    widowed: "Widowed",
    "Chiropractor": "Chiropractor",
    "Doctor": "Doctor",
    "Dentist": "Dentist",
    "Dietitian or Nutritionist": "Dietitian or Nutritionist",
    "Optometrist": "Optometrist",
    "Pharmacist": "Pharmacist",
    "Physician": "Physician",
    "Physician Assistant": "Physician Assistant",
    "Podiatrist": "Podiatrist",
    "Registered Nurse": "Registered Nurse",
    "Therapist": "Therapist",
    "Veterinarian": "Veterinarian",
    "Health Technologist or Technician": "Health Technologist or Technician",
    "Other Healthcare Practitioners and Technical Occupation": "Other Healthcare Practitioners and Technical Occupation",
    "Nursing, Psychiatric, or Home Health Aide": "Nursing, Psychiatric, or Home Health Aide",
    "Occupational and Physical Therapist Assistant or Aide": "Occupational and Physical Therapist Assistant or Aide",
    "Other Healthcare Support Occupation": "Other Healthcare Support Occupation",
    "Chief Executive": "Chief Executive",
    "General and Operations Manager": "General and Operations Manager",
    "Advertising, Marketing, Promotions, Public Relations, and Sales Manager": "Advertising, Marketing, Promotions, Public Relations, and Sales Manager",
    "Operations Specialties Manager (e.g., IT or HR Manager)": "Operations Specialties Manager (e.g., IT or HR Manager)",
    "Construction Manager": "Construction Manager",
    "Engineering Manager": "Engineering Manager",
    "Accountant, Auditor": "Accountant, Auditor",
    "Business Operations or Financial Specialist": "Business Operations or Financial Specialist",
    "Business Owner": "Business Owner",
    "Other Business, Executive, Management, Financial Occupation": "Other Business, Executive, Management, Financial Occupation",
    "Architect, Surveyor, or Cartographer": "Architect, Surveyor, or Cartographer",
    "Engineer": "Engineer",
    "Other Architecture and Engineering Occupation": "Other Architecture and Engineering Occupation",
    "Postsecondary Teacher (e.g., College Professor)": "Postsecondary Teacher (e.g., College Professor)",
    "Primary, Secondary, or Special Education School Teacher": "Primary, Secondary, or Special Education School Teacher",
    "Other Teacher or Instructor": "Other Teacher or Instructor",
    "Other Education, Training, and Library Occupation": "Other Education, Training, and Library Occupation",
    "Arts, Design, Entertainment, Sports, and Media Occupations": "Arts, Design, Entertainment, Sports, and Media Occupations",
    "Computer Specialist, Mathematical Science": "Computer Specialist, Mathematical Science",
    "Counselor, Social Worker, or Other Community and Social Service Specialist": "Counselor, Social Worker, or Other Community and Social Service Specialist",
    "Lawyer, Judge": "Lawyer, Judge",
    "Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)": "Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)",
    "Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)": "Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)",
    "Religious Worker (e.g., Clergy, Director of Religious Activities or Education)": "Religious Worker (e.g., Clergy, Director of Religious Activities or Education)",
    "Social Scientist and Related Worker": "Social Scientist and Related Worker",
    "Other Professional Occupation": "Other Professional Occupation",
    "Supervisor of Administrative Support Workers": "Supervisor of Administrative Support Workers",
    "Financial Clerk": "Financial Clerk",
    "Secretary or Administrative Assistant": "Secretary or Administrative Assistant",
    "Material Recording, Scheduling, and Dispatching Worker": "Material Recording, Scheduling, and Dispatching Worker",
    "Other Office and Administrative Support Occupation": "Other Office and Administrative Support Occupation",
    "Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)": "Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)",
    "Chef or Head Cook": "Chef or Head Cook",
    "Cook or Food Preparation Worker": "Cook or Food Preparation Worker",
    "Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)": "Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)",
    "Building and Grounds Cleaning and Maintenance": "Building and Grounds Cleaning and Maintenance",
    "Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)": "Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)",
    "Sales Supervisor, Retail Sales": "Sales Supervisor, Retail Sales",
    "Retail Sales Worker": "Retail Sales Worker",
    "Insurance Sales Agent": "Insurance Sales Agent",
    "Sales Representative": "Sales Representative",
    "Real Estate Sales Agent": "Real Estate Sales Agent",
    "Other Services Occupation": "Other Services Occupation",
    "Construction and Extraction (e.g., Construction Laborer, Electrician)": "Construction and Extraction (e.g., Construction Laborer, Electrician)",
    "Farming, Fishing, and Forestry": "Farming, Fishing, and Forestry",
    "Installation, Maintenance, and Repair": "Installation, Maintenance, and Repair",
    "Production Occupations": "Production Occupations",
    "Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation": "Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation",
    "Aircraft Pilot or Flight Engineer": "Aircraft Pilot or Flight Engineer",
    "Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)": "Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)",
    "Other Transportation Occupation": "Other Transportation Occupation",
    "Military": "Military",
    "Homemaker": "Homemaker",
    "Other Occupation": "Other Occupation",
    "Don't Know": "Don't Know",
    "Not Applicable": "Not Applicable",
    "validation.nationalId.sa.format": "ID must be exactly 10 digits",
    "validation.nationalId.sa.national_id_start": "Saudi National ID must start with 1",
    "validation.nationalId.sa.iqama_start": "Iqama / Residency number must start with 2",
    "validation.nationalId.eg.format": "Egyptian National ID must be exactly 14 digits",
    "validation.nationalId.eg.invalid": "Egyptian National ID has an invalid date or century digit",
    "visa": "VISA",
    "border_number": "Border Number",
    "displaced_person": "Displaced Person",
    label_nphiesCode_tooltip: "This is an insurance-company setting, not a patient detail. The value entered here is used for this eligibility request only and is not saved to the insurance company record. To store it permanently, set the NPHIES Code on the insurance company (Associates → Insurance Companies).",
    label_policyNumber_tooltip: "The Policy Number from the patient's Insurance Policy on file, sent with this eligibility request. Anything entered here applies to this request only — to change the stored value, update the patient's insurance record.",
    label_coverageType_tooltip: "The Coverage Type from the patient's Policy Class on file, sent with this eligibility request. Anything entered here applies to this request only — to change the stored value, update the patient's insurance record."
  },
  ckb: {
    check_button: "پشکنینی شایستەیی",
    recheck_button: "پشکنینەوەی شایستەیی",
    status_eligible: "شایستەیە",
    status_non_eligible: "شایستە نییە",
    status_unavailable: "بەردەست نییە",
    success_title: "پشکنینی شایستەیی بە سەرکەوتوویی ئەنجامدرا",
    error_title: "پشکنینی شایستەیی سەرکەوتوو نەبوو",
    modal_title: "خانە بەتاڵەکان پڕ بکەرەوە",
    label_nationalId: "ناسنامەی نیشتمانی",
    label_firstName: "ناوی یەکەم",
    label_lastName: "ناوی خێزان",
    label_nphiesCode: "کۆدی NPHIESی کۆمپانیای دڵنیایی",
    label_tpaNphiesCode: "کۆدی NPHIESی TPA",
    placeholder_nphiesCode: "کۆدی NPHIESی کۆمپانیای دڵنیایی داخڵ بکە",
    label_policyNumber: "ژمارەی پۆڵیسە",
    label_coverageType: "جۆری داپۆشین",
    label_membershipNumber: "ژمارەی ئەندامییەتی",
    "auth.nameLength": "ناسنامە ناتوانێت لە ١٠٠ پیت زیاتر بێت",
    msg_membershipNumberLength: "ژمارەی ئەندامییەتی ناتوانێت لە ١٠٠ پیت زیاتر بێت",
    label_serviceDate: "بەرواری خزمەتگوزاری",
    label_birthDate: "بەرواری لەدایکبوون",
    label_identifierType: "جۆری ناسنامە",
    label_gender: "ڕەگەز",
    label_maritalStatus: "باری خێزانی",
    label_occupation: "پیشە",
    label_lastChecked: "دوایین پشکنین",
    required: "پێویستە",
    title_eligibilityResult: "ئەنجامی شایستەیی",
    tooltip_insurance_missing: "مستهقنی بەردەست نییە چونکە زانیاری بیمە کەم و کورتە",
    hint_previewOnly: "ئەم پشکنینی شایستەییە تەنها بۆ پێشبینینە و لە پرۆفایلی نەخۆشدا پاشەکەوت ناکرێت. دوای دروستکردنی نەخۆش، دەتوانیت دووبارە شایستەیی بپشکنیت و پاشەکەوتی بکەیت.",
    button_close: "داخستن",
    label_payerName: "ناوی بژێرەر",
    label_responseDate: "بەرواری وەڵامدانەوە",
    label_payerReferenceNumber: "ژمارەی سەرچاوەی بژێرەر",
    label_remarks: "تێبینییەکان",
    label_errors: "هەڵەکان",
    label_policyHolderName: "ناوی خاوەن پۆڵیسە",
    label_inceptionDate: "بەرواری دەستپێکی دڵنیایی",
    label_expiryDate: "بەرواری بەسەرچوونی دڵنیایی",
    label_providerName: "ناوی دابینکەر",
    label_requestDate: "بەرواری داواکاری",
    patient_updated_successfully: "داتای نەخۆش بە سەرکەوتوویی نوێکرایەوە",
    error_updating_patient: "هەڵەیەک ڕوویدا لە نوێکردنەوەی داتای نەخۆش",
    "Coverage is in-force": "دڵنیاییەکە کارایە",
    national_id: "ناسنامەی نیشتمانی",
    passport: "پاسپۆرت",
    driver_license: "هیتر",
    residency: "ئیقامە",
    iqama: "ئیقامە",
    OTHER: "هیتر",
    other: "هیتر",
    male: "نێر",
    female: "مێ",
    married: "هاوسەردار",
    single: "سەڵت",
    divorced: "جیابووەوە",
    separated: "جیاواز",
    widowed: "بێوەژن/بێوەپیاو",
    "Chiropractor": "پزیشکی ئێسک و جومگە",
    "Doctor": "پزیشک",
    "Dentist": "پزیشکی ددان",
    "Dietitian or Nutritionist": "پزیشکی خۆراک",
    "Optometrist": "پزیشکی چاو",
    "Pharmacist": "دەرمانساز",
    "Physician": "پزیشکی گشتی",
    "Physician Assistant": " یاریدەدەری پزیشک",
    "Podiatrist": "پزیشکی قاچ",
    "Registered Nurse": "پەرستاری ڕێپێدراو",
    "Therapist": "چارەسەرکار",
    "Veterinarian": "پزیشکی ڤێتێرنەری",
    "Health Technologist or Technician": "تەکنیکاری تەندروستی",
    "Other Healthcare Practitioners and Technical Occupation": "کارمەندانی تری تەندروستی",
    "Nursing, Psychiatric, or Home Health Aide": "یاریدەدەری پەرستاری یان دەروونی",
    "Occupational and Physical Therapist Assistant or Aide": "یاریدەدەری چارەسەری سروشتی",
    "Other Healthcare Support Occupation": "پیشەکانی تری پاڵپشتی تەندروستی",
    "Chief Executive": "بەڕێوەبەری جێبەجێکار",
    "General and Operations Manager": "بەڕێوەبەری گشتی و کارگێڕی",
    "Advertising, Marketing, Promotions, Public Relations, and Sales Manager": "بەڕێوەبەری مارکێتینگ و فرۆشتن",
    "Operations Specialties Manager (e.g., IT or HR Manager)": "بەڕێوەبەری پسپۆڕی (وەک IT یان HR)",
    "Construction Manager": "بەڕێوەبەری بیناسازی",
    "Engineering Manager": "بەڕێوەبەری ئەندازیاری",
    "Accountant, Auditor": "ژمێریار، وردبین",
    "Business Operations or Financial Specialist": "پسپۆڕی دارایی یان کارگێڕی",
    "Business Owner": "خاوەن کار",
    "Other Business, Executive, Management, Financial Occupation": "پیشەکانی تری کارگێڕی و دارایی",
    "Architect, Surveyor, or Cartographer": "ئەندازیاری تەلارساز یان ڕووپێو",
    "Engineer": "ئەندازیار",
    "Other Architecture and Engineering Occupation": "پیشەکانی تری ئەندازیاری",
    "Postsecondary Teacher (e.g., College Professor)": "مامۆستای زانکۆ",
    "Primary, Secondary, or Special Education School Teacher": "مامۆستای قوتابخانە",
    "Other Teacher or Instructor": "مامۆستا یان ڕاهێنەری تر",
    "Other Education, Training, and Library Occupation": "پیشەکانی تری پەروەردە و کتێبخانە",
    "Arts, Design, Entertainment, Sports, and Media Occupations": "پیشەکانی هونەر، وەرزش و میدیا",
    "Computer Specialist, Mathematical Science": "پسپۆڕی کۆمپیوتەر و ماتماتیک",
    "Counselor, Social Worker, or Other Community and Social Service Specialist": "توێژەری کۆمەڵایەتی",
    "Lawyer, Judge": "پارێزەر، دادوەر",
    "Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)": "زانای زیندەوەرزانی",
    "Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)": "زانای فیزیا و کیمیا",
    "Religious Worker (e.g., Clergy, Director of Religious Activities or Education)": "کارمەندی ئایینی",
    "Social Scientist and Related Worker": "زانای کۆمەڵایەتی",
    "Other Professional Occupation": "پیشە ئەکادیمییەکانی تر",
    "Supervisor of Administrative Support Workers": "سەرپەرشتیاری کارگێڕی",
    "Financial Clerk": "کارمەندی دارایی",
    "Secretary or Administrative Assistant": "سکرتێر یان یاریدەدەری کارگێڕی",
    "Material Recording, Scheduling, and Dispatching Worker": "کارمەندی گۆگای و خشتەبەندی",
    "Other Office and Administrative Support Occupation": "پیشەکانی تری نووسینگە",
    "Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)": "خزمەتگوزارییە پارێزگارییەکان",
    "Chef or Head Cook": "شێف یان سەرۆک چێشتلێنەر",
    "Cook or Food Preparation Worker": "چێشتلێنەر",
    "Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)": "گارسۆن",
    "Building and Grounds Cleaning and Maintenance": "پاککردنەوە و چاککردنەوەی باڵەخانە",
    "Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)": "خزمەتگوزاری کەسی",
    "Sales Supervisor, Retail Sales": "سەرپەرشتیاری فرۆشتن",
    "Retail Sales Worker": "فرۆشیار",
    "Insurance Sales Agent": "بریکاری فرۆشتنی دڵنیایی",
    "Sales Representative": "نوێنەری فرۆشتن",
    "Real Estate Sales Agent": "بریکاری خانووبەرە",
    "Other Services Occupation": "پیشەکانی تری خزمەتگوزاری",
    "Construction and Extraction (e.g., Construction Laborer, Electrician)": "بیناسازی و کارەبا",
    "Farming, Fishing, and Forestry": "کشتوکاڵ و ڕاوچییەتی",
    "Installation, Maintenance, and Repair": "دامەزراندن و چاککردنەوە",
    "Production Occupations": "پیشەکانی بەرهەمهێنان",
    "Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation": "کارە دەستییەکان و کشتوکاڵ",
    "Aircraft Pilot or Flight Engineer": "فڕۆکەوان",
    "Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)": "شۆفێری ئۆتۆمبێل",
    "Other Transportation Occupation": "پیشەکانی تری گواستنەوە",
    "Military": "سەربازی",
    "Homemaker": "کەبانوو (ماڵداری)",
    "Other Occupation": "پیشەی تر",
    "Don't Know": "نازانم",
    "Not Applicable": "نایگرێتەوە",
    "validation.nationalId.sa.format": "پێویستە ژمارەی ناسنامە ڕێک ١٠ ژمارە بێت",
    "validation.nationalId.sa.national_id_start": "ناسنامەی نیشتمانی سعودی دەبێت بە ١ دەست پێ بکات",
    "validation.nationalId.sa.iqama_start": "ژمارەی ئیقامە / نیشتەجێبوون دەبێت بە ٢ دەست پێ بکات",
    "validation.nationalId.eg.format": "ناسنامەی نیشتمانی میسری دەبێت ڕێک ١٤ ژمارە بێت",
    "validation.nationalId.eg.invalid": "ناسنامەی نیشتمانی میسری بەروار یان سەدەی نادروستی تێدایە",
    "visa": "ڤیزە",
    "border_number": "ژمارەی سنوور",
    "displaced_person": "کەسی ئاوارە",
    label_nphiesCode_tooltip: "ئەمە ڕێکخستنی کۆمپانیای بیمەیە، نەک زانیاری نەخۆش. ئەو بەهایەی لێرە دەنووسرێت تەنها بۆ ئەم داواکاریی شایستەییە بەکاردێت و لە تۆماری کۆمپانیای بیمە پاشەکەوت ناکرێت. بۆ پاشەکەوتکردنی هەمیشەیی، کۆدی NPHIES لەسەر کۆمپانیای بیمە دابنێ (هاوبەشەکان ← کۆمپانیاکانی بیمە).",
    label_policyNumber_tooltip: "ژمارەی پۆڵیسە کە لە سیاسەتی بیمەی تۆمارکراوی نەخۆشەکە هاتووە، لەگەڵ ئەم داواکاریی شایستەییە دەنێردرێت. ئەوەی لێرە دەنووسرێت تەنها بۆ ئەم داواکارییەیە — بۆ گۆڕینی بەها پاشەکەوتکراوەکە، تۆماری بیمەی نەخۆش نوێ بکەرەوە.",
    label_coverageType_tooltip: "جۆری داپۆشین کە لە پۆلی سیاسەتی تۆمارکراوی نەخۆشەکە هاتووە، لەگەڵ ئەم داواکاریی شایستەییە دەنێردرێت. ئەوەی لێرە دەنووسرێت تەنها بۆ ئەم داواکارییەیە — بۆ گۆڕینی بەها پاشەکەوتکراوەکە، تۆماری بیمەی نەخۆش نوێ بکەرەوە."
  },
  el: {
    check_button: "Έλεγχος επιλεξιμότητας",
    recheck_button: "Επανέλεγχος επιλεξιμότητας",
    status_eligible: "Επιλέξιμος",
    status_non_eligible: "Μη επιλέξιμος",
    status_unavailable: "Μη διαθέσιμο",
    success_title: "Επιτυχής έλεγχος επιλεξιμότητας",
    error_title: "Αποτυχία ελέγχου επιλεξιμότητας",
    modal_title: "Συμπληρώστε τα πεδία που λείπουν",
    label_nationalId: "Εθνικό ID",
    label_firstName: "Όνομα",
    label_lastName: "Επώνυμο",
    label_nphiesCode: "Κωδικός NPHIES ασφαλιστικής",
    label_tpaNphiesCode: "Κωδικός NPHIES TPA",
    placeholder_nphiesCode: "Εισαγάγετε κωδικό NPHIES",
    label_policyNumber: "Αριθμός συμβολαίου",
    label_coverageType: "Τύπος κάλυψης",
    label_membershipNumber: "Αριθμός Μέλους",
    "auth.nameLength": "Ο αριθμός ταυτότητας δεν μπορεί να υπερβαίνει τους 100 χαρακτήρες",
    msg_membershipNumberLength: "Ο αριθμός μέλους δεν μπορεί να υπερβαίνει τους 100 χαρακτήρες",
    label_serviceDate: "Ημερομηνία υπηρεσίας",
    label_birthDate: "Ημερομηνία γέννησης",
    label_identifierType: "Τύπος αναγνωριστικού",
    label_gender: "Φύλο",
    label_maritalStatus: "Οικογενειακή κατάσταση",
    label_occupation: "Επάγγελμα",
    label_lastChecked: "Τελευταίος έλεγχος",
    required: "Απαιτείται",
    title_eligibilityResult: "Αποτέλεσμα επιλεξιμότητας",
    tooltip_insurance_missing: "Η επιλεξιμότητα δεν είναι διαθέσιμη επειδή λείπουν πληροφορίες ασφάλισης",
    hint_previewOnly: "Αυτός ο έλεγχος επιλεξιμότητας είναι μόνο για προεπισκόπηση και δεν θα αποθηκευτεί στο προφίλ του ασθενούς. Μετά τη δημιουργία του ασθενούς, μπορείτε να επανελέγξετε την επιλεξιμότητα και να την αποθηκεύσετε.",
    button_close: "Κλείσιμο",
    label_payerName: "Όνομα πληρωτή",
    label_responseDate: "Ημερομηνία απάντησης",
    label_payerReferenceNumber: "Αριθμός αναφοράς πληρωτή",
    label_remarks: "Σχόλια",
    label_errors: "Σφάλματα",
    label_policyHolderName: "Όνομα κατόχου συμβολαίου",
    label_inceptionDate: "Ημερομηνία έναρξης ασφάλισης",
    label_expiryDate: "Ημερομηνία λήξης ασφάλισης",
    label_providerName: "Όνομα παρόχου",
    label_requestDate: "Ημερομηνία αιτήματος",
    patient_updated_successfully: "Τα στοιχεία του ασθενούς ενημερώθηκαν με επιτυχία",
    error_updating_patient: "Αποτυχία ενημέρωσης των στοιχείων του ασθενούς",
    "Coverage is in-force": "Η κάλυψη είναι σε ισχύ",
    national_id: "Εθνικό ID",
    passport: "Διαβατήριο",
    driver_license: "Άδεια οδήγησης",
    residency: "Διαμονή",
    iqama: "Άδεια διαμονής (Iqama)",
    OTHER: "Άλλο",
    other: "Άλλο",
    male: "Άνδρας",
    female: "Γυναίκα",
    married: "Έγγαμος",
    single: "Άγαμος",
    divorced: "Διαζευγμένος",
    separated: "Σε διάσταση",
    widowed: "Χήρος/α",
    "Doctor": "Γιατρός",
    "Dentist": "Οδοντίατρος",
    "Pharmacist": "Φαρμακοποιός",
    "Engineer": "Μηχανικός",
    "Accountant, Auditor": "Λογιστής, Ελεγκτής",
    "Business Owner": "Ιδιοκτήτης επιχείρησης",
    "Military": "Στρατιωτικός",
    "Homemaker": "Νοικοκυρά",
    "Other Occupation": "Άλλο επάγγελμα",
    "Don't Know": "Δεν γνωρίζω",
    "Not Applicable": "Δεν ισχύει",
    "validation.nationalId.sa.format": "Η ταυτότητα πρέπει να είναι ακριβώς 10 ψηφία",
    "validation.nationalId.sa.national_id_start": "Η εθνική ταυτότητα της Σαουδικής Αραβίας πρέπει να ξεκινά με 1",
    "validation.nationalId.sa.iqama_start": "Ο αριθμός Iqama / διαμονής πρέπει να ξεκινά με 2",
    "validation.nationalId.eg.format": "Η αιγυπτιακή εθνική ταυτότητα πρέπει να είναι ακριβώς 14 ψηφία",
    "validation.nationalId.eg.invalid": "Η αιγυπτιακή εθνική ταυτότητα έχει μη έγκυρη ημερομηνία ή αιώνα",
    "visa": "Βίζα",
    "border_number": "Αριθμός συνόρων",
    "displaced_person": "Εκτοπισμένο άτομο",
    label_nphiesCode_tooltip: "Πρόκειται για ρύθμιση της ασφαλιστικής εταιρείας, όχι για στοιχείο ασθενούς. Η τιμή που εισάγεται εδώ χρησιμοποιείται μόνο για αυτό το αίτημα επιλεξιμότητας και δεν αποθηκεύεται στην καρτέλα της ασφαλιστικής. Για μόνιμη αποθήκευση, ορίστε τον κωδικό NPHIES στην ασφαλιστική εταιρεία (Συνεργάτες → Ασφαλιστικές Εταιρείες).",
    label_policyNumber_tooltip: "Ο Αριθμός συμβολαίου από το καταχωρημένο ασφαλιστήριο συμβόλαιο του ασθενούς, που αποστέλλεται με αυτό το αίτημα επιλεξιμότητας. Ό,τι εισαχθεί εδώ ισχύει μόνο για αυτό το αίτημα — για να αλλάξετε την αποθηκευμένη τιμή, ενημερώστε το ασφαλιστικό αρχείο του ασθενούς.",
    label_coverageType_tooltip: "Ο Τύπος κάλυψης από την καταχωρημένη κλάση πολιτικής του ασθενούς, που αποστέλλεται με αυτό το αίτημα επιλεξιμότητας. Ό,τι εισαχθεί εδώ ισχύει μόνο για αυτό το αίτημα — για να αλλάξετε την αποθηκευμένη τιμή, ενημερώστε το ασφαλιστικό αρχείο του ασθενούς."
  },
  fr: {
    check_button: "Vérifier l'éligibilité",
    recheck_button: "Re-vérifier l'éligibilité",
    status_eligible: "Éligible",
    status_non_eligible: "Non éligible",
    status_unavailable: "Indisponible",
    success_title: "Éligibilité vérifiée avec succès",
    error_title: "Échec de la vérification de l'éligibilité",
    modal_title: "Remplir les champs manquants",
    label_nationalId: "ID National",
    label_firstName: "Prénom",
    label_lastName: "Nom",
    label_nphiesCode: "Code NPHIES de l'assurance",
    label_tpaNphiesCode: "Code NPHIES du TPA",
    placeholder_nphiesCode: "Entrer le code NPHIES",
    label_policyNumber: "Numéro de police",
    label_coverageType: "Type de couverture",
    label_membershipNumber: "Numéro d'adhérent",
    "auth.nameLength": "L'identifiant ne peut pas dépasser 100 caractères",
    msg_membershipNumberLength: "Le numéro d'adhérent ne peut pas dépasser 100 caractères",
    label_serviceDate: "Date du service",
    label_birthDate: "Date de naissance",
    label_identifierType: "Type d'identifiant",
    label_gender: "Genre",
    label_maritalStatus: "État civil",
    label_occupation: "Occupation",
    label_lastChecked: "Dernière vérification",
    required: "Requis",
    title_eligibilityResult: "Résultat d'éligibilité",
    tooltip_insurance_missing: "L'éligibilité n'est pas disponible car les informations d'assurance sont manquantes",
    hint_previewOnly: "Cette vérification d'éligibilité est uniquement à titre d'aperçu et ne sera pas enregistrée dans le profil du patient. Après la création du patient, vous pourrez revérifier l'éligibilité et l'enregistrer.",
    button_close: "Fermer",
    label_payerName: "Nom du payeur",
    label_responseDate: "Date de réponse",
    label_payerReferenceNumber: "N° de référence du payeur",
    label_remarks: "Remarques",
    label_errors: "Erreurs",
    label_policyHolderName: "Nom du titulaire",
    label_inceptionDate: "Date d'effet",
    label_expiryDate: "Date d'expiration",
    label_providerName: "Nom du prestataire",
    label_requestDate: "Date de demande",
    patient_updated_successfully: "Les données du patient ont été mises à jour avec succès",
    error_updating_patient: "Échec de la mise à jour des données du patient",
    "Coverage is in-force": "La couverture est en vigueur",
    national_id: "ID National",
    passport: "Passeport",
    driver_license: "Permis de conduire",
    residency: "Résidence",
    iqama: "Résidence (Iqama)",
    OTHER: "Autre",
    other: "Autre",
    male: "Homme",
    female: "Femme",
    married: "Marié(e)",
    single: "Célibataire",
    divorced: "Divorcé(e)",
    separated: "Séparé(e)",
    widowed: "Veuf/Veuve",
    "Doctor": "Docteur",
    "Dentist": "Dentiste",
    "Pharmacist": "Pharmacien",
    "Engineer": "Ingénieur",
    "Accountant, Auditor": "Comptable",
    "Business Owner": "Propriétaire d'entreprise",
    "Military": "Militaire",
    "Homemaker": "Au foyer",
    "Don't Know": "Je ne sais pas",
    "Not Applicable": "Non applicable",
    "validation.nationalId.sa.format": "La carte d'identité doit comporter exactement 10 chiffres",
    "validation.nationalId.sa.national_id_start": "La carte d'identité nationale saoudienne doit commencer par 1",
    "validation.nationalId.sa.iqama_start": "Le numéro de l'Iqama / résidence doit commencer par 2",
    "validation.nationalId.eg.format": "La carte d'identité nationale égyptienne doit comporter exactement 14 chiffres",
    "validation.nationalId.eg.invalid": "La carte d'identité nationale égyptienne a une date ou un siècle invalide",
    "visa": "VISA",
    "border_number": "Numéro de frontière",
    "displaced_person": "Personne déplacée",
    label_nphiesCode_tooltip: "Il s'agit d'un paramètre de la compagnie d'assurance, et non d'une donnée patient. La valeur saisie ici n'est utilisée que pour cette demande d'éligibilité et n'est pas enregistrée dans la fiche de l'assureur. Pour la conserver, renseignez le code NPHIES sur la compagnie d'assurance (Partenaires → Compagnies d'assurance).",
    label_policyNumber_tooltip: "Le Numéro de police issu de la police d'assurance enregistrée du patient, envoyé avec cette demande d'éligibilité. Ce qui est saisi ici ne vaut que pour cette demande — pour modifier la valeur enregistrée, mettez à jour la fiche d'assurance du patient.",
    label_coverageType_tooltip: "Le Type de couverture issu de la classe de politique enregistrée du patient, envoyé avec cette demande d'éligibilité. Ce qui est saisi ici ne vaut que pour cette demande — pour modifier la valeur enregistrée, mettez à jour la fiche d'assurance du patient."
  },
  it: {
    check_button: "Verifica idoneità",
    recheck_button: "Riaffina verifica idoneità",
    status_eligible: "Idoneo",
    status_non_eligible: "Non idoneo",
    status_unavailable: "Non disponibile",
    success_title: "Idoneità verificata con successo",
    error_title: "Verifica idoneità fallita",
    modal_title: "Compila i campi mancanti",
    label_nationalId: "ID Nazionale",
    label_firstName: "Nome",
    label_lastName: "Cognome",
    label_nphiesCode: "Codice NPHIES assicurazione",
    label_tpaNphiesCode: "Codice NPHIES TPA",
    placeholder_nphiesCode: "Inserisci codice NPHIES",
    label_policyNumber: "Numero polizza",
    label_coverageType: "Tipo copertura",
    label_membershipNumber: "Numero Socio",
    "auth.nameLength": "L'identificativo non può superare i 100 caratteri",
    msg_membershipNumberLength: "Il numero socio non può superare i 100 caratteri",
    label_serviceDate: "Data servizio",
    label_birthDate: "Data di nascita",
    label_identifierType: "Tipo identificativo",
    label_gender: "Genere",
    label_maritalStatus: "Stato civile",
    label_occupation: "Occupazione",
    label_lastChecked: "Ultima verifica",
    required: "Obbligatorio",
    title_eligibilityResult: "Risultato idoneità",
    tooltip_insurance_missing: "L'idoneità non è disponibile perché le informazioni sull'assicurazione sono mancanti",
    hint_previewOnly: "Questo controllo di idoneità è solo per anteprima e non verrà salvato nel profilo del paziente. Dopo aver creato il paziente, potrai riverificare l'idoneità e salvarla.",
    button_close: "Chiudi",
    label_payerName: "Nome pagatore",
    label_responseDate: "Data risposta",
    label_payerReferenceNumber: "Numero riferimento pagatore",
    label_remarks: "Note",
    label_errors: "Errori",
    label_policyHolderName: "Nome contraente",
    label_inceptionDate: "Data inizio assicurazione",
    label_expiryDate: "Data scadenza assicurazione",
    label_providerName: "Nome fornitore",
    label_requestDate: "Data richiesta",
    patient_updated_successfully: "I dati del paziente sono stati aggiornati con successo",
    error_updating_patient: "Errore durante l'aggiornamento dei dati del paziente",
    "Coverage is in-force": "Copertura in vigore",
    national_id: "ID Nazionale",
    passport: "Passaporto",
    driver_license: "Patente di guida",
    residency: "Residenza",
    iqama: "Residenza (Iqama)",
    OTHER: "Altro",
    other: "Altro",
    male: "Maschio",
    female: "Femmina",
    married: "Sposato/a",
    single: "Celibe/Nubile",
    divorced: "Divorziato/a",
    separated: "Separato/a",
    widowed: "Vedovo/a",
    "Doctor": "Medico",
    "Dentist": "Dentista",
    "Pharmacist": "Farmacista",
    "Engineer": "Ingegnere",
    "Accountant, Auditor": "Contabile",
    "Business Owner": "Imprenditore",
    "Military": "Militare",
    "Homemaker": "Casalinga/o",
    "Don't Know": "Non so",
    "Not Applicable": "Non applicabile",
    "validation.nationalId.sa.format": "L'ID deve contenere esattamente 10 cifre",
    "validation.nationalId.sa.national_id_start": "L'ID nazionale saudita deve iniziare con 1",
    "validation.nationalId.sa.iqama_start": "Il numero Iqama / di residenza deve iniziare con 2",
    "validation.nationalId.eg.format": "L'ID nazionale egiziano deve contenere esattamente 14 cifre",
    "validation.nationalId.eg.invalid": "L'ID nazionale egiziano ha una data o un secolo non validi",
    "visa": "Visto",
    "border_number": "Numero di confine",
    "displaced_person": "Persona sfollata",
    label_nphiesCode_tooltip: "Questa è un'impostazione della compagnia assicurativa, non un dato del paziente. Il valore inserito qui viene usato solo per questa richiesta di idoneità e non viene salvato nella scheda dell'assicurazione. Per conservarlo, imposta il codice NPHIES sulla compagnia assicurativa (Partner → Compagnie assicurative).",
    label_policyNumber_tooltip: "Il Numero polizza dalla polizza assicurativa registrata del paziente, inviato con questa richiesta di idoneità. Quanto inserito qui vale solo per questa richiesta — per modificare il valore salvato, aggiorna la scheda assicurativa del paziente.",
    label_coverageType_tooltip: "Il Tipo copertura dalla classe di polizza registrata del paziente, inviato con questa richiesta di idoneità. Quanto inserito qui vale solo per questa richiesta — per modificare il valore salvato, aggiorna la scheda assicurativa del paziente."
  },
  ku: {
    check_button: "Kontrola şayestebûnê",
    recheck_button: "Dîsa kontrol bike",
    status_eligible: "Şayeste ye",
    status_non_eligible: "Ne şayeste ye",
    status_unavailable: "Nepeyda",
    success_title: "Kontrola şayestebûnê serkeftî bû",
    error_title: "Kontrola şayestebûnê bi ser neket",
    modal_title: "Zانیارییێن kêm tije bike",
    label_nationalId: "Nasnameya neteweyî",
    label_firstName: "Nav",
    label_lastName: "Paşnav",
    label_nphiesCode: "Koda NPHIES ya şîrketê",
    label_tpaNphiesCode: "Koda NPHIES ya TPA",
    placeholder_nphiesCode: "Koda NPHIES بنivîse",
    label_policyNumber: "Hejmara polîçeyê",
    label_coverageType: "Cureyê sîgortayê",
    label_membershipNumber: "Hejmara Endamtiyê",
    "auth.nameLength": "Nasname nikare ji 100 tîpan zêdetir be",
    msg_membershipNumberLength: "Hejmara endamtiyê nikare ji 100 tîpan zêdetir be",
    label_serviceDate: "Dîroka xizmetê",
    label_birthDate: "Dîroka ji dayikbûnê",
    label_identifierType: "Cureyê nasnameyê",
    label_gender: "Zayend",
    label_maritalStatus: "Rewşa zewacê",
    label_occupation: "Kar/Pîşe",
    label_lastChecked: "Kontrola dawî",
    required: "Pêdivî ye",
    title_eligibilityResult: "Encama şayestebûnê",
    tooltip_insurance_missing: "Destûrname peyda nabe ji ber ku agahiyên bîmeyê kêm in",
    hint_previewOnly: "Ev kontrola şayestebûnê tenê ji bo pêşdîtinê ye û dê di profîla nexweş de neyê tomarkirin. Piştî ku nexweş hat afirandin, tu dikarî şayestebûnê dîsa kontrol bikî û tomar bikî.",
    button_close: "Bigire",
    label_payerName: "Navê dander",
    label_responseDate: "Dîroka bersivê",
    label_payerReferenceNumber: "Hejmara referansa dander",
    label_remarks: "Têbînî",
    label_errors: "Çewtî",
    label_policyHolderName: "Navê xwediyê polîçeyê",
    label_inceptionDate: "Dîroka destpêka sîgortayê",
    label_expiryDate: "Dîroka qedandina sîgortayê",
    label_providerName: "Navê dabînker",
    label_requestDate: "Dîroka daxwazê",
    patient_updated_successfully: "داتای نەخۆش بە سەرکەوتوویی نوێکرایەوە",
    error_updating_patient: "هەڵەیەک لە نوێکردنەوەی داتای نەخۆش ڕوویدا",
    "Coverage is in-force": "Sîgorta çalak e",
    national_id: "Nasnameya neteweyî",
    passport: "Pasaport",
    driver_license: "Ehliyet",
    residency: "Niştecîbûn",
    iqama: "Îqame",
    OTHER: "Yên din",
    other: "Yên din",
    male: "Nêr",
    female: "Mê",
    married: "Zewicî",
    single: "Ezeb",
    divorced: "Berdayî",
    separated: "Veqetandî",
    widowed: " بیوەژن/بیوەپیاو",
    "Doctor": "Bijîşk",
    "Dentist": "Bijîşkê dindan",
    "Pharmacist": "Dermanfiroş",
    "Engineer": "Endazyar",
    "Business Owner": "Xwediyê kar",
    "Military": "Leşkerî",
    "Homemaker": "Kebanî",
    "Don't Know": "Ez nizanim",
    "Not Applicable": "Nabe",
    "validation.nationalId.sa.format": "Divê nasname bi rastî 10 hejmar be",
    "validation.nationalId.sa.national_id_start": "Nasnameya neteweyî ya Siûdî divê bi 1 dest pê bike",
    "validation.nationalId.sa.iqama_start": "Hejmara Îqame / rûniştinê divê bi 2 dest pê bike",
    "validation.nationalId.eg.format": "Nasnameya neteweyî ya Misrê divê bi rastî 14 hejmar be",
    "validation.nationalId.eg.invalid": "Nasnameya neteweyî ya Misrê tarîx an sedsalek nederbasdar e",
    "visa": "Vîza",
    "border_number": "Hejmara Sînor",
    "displaced_person": "Kesê Aware",
    label_nphiesCode_tooltip: "Ev mîhenga şîrketa bîmeyê ye, ne agahiyeke nexweş. Nirxa ku li vir tê nivîsîn tenê ji bo vê daxwaza mafdariyê tê bikaranîn û di tomara şîrketa bîmeyê de nayê tomarkirin. Ji bo tomarkirina domdar, koda NPHIES li ser şîrketa bîmeyê saz bike (Hevkar → Şîrketên Bîmeyê).",
    label_policyNumber_tooltip: "Hejmara polîçeyê ji polîtîkaya sîgorteyê ya tomarkirî ya nexweş, bi vê daxwaza mafdariyê re tê şandin. Tiştê ku li vir tê nivîsîn tenê ji bo vê daxwazê ye — ji bo guhertina nirxa tomarkirî, tomara sîgorteyê ya nexweş nû bike.",
    label_coverageType_tooltip: "Cureyê sîgortayê ji pola polîtîkayê ya tomarkirî ya nexweş, bi vê daxwaza mafdariyê re tê şandin. Tiştê ku li vir tê nivîsîn tenê ji bo vê daxwazê ye — ji bo guhertina nirxa tomarkirî, tomara sîgorteyê ya nexweş nû bike."
  },
  nl: {
    check_button: "Check geschiktheid",
    recheck_button: "Opnieuw checken",
    status_eligible: "In aanmerking komend",
    status_non_eligible: "Niet in aanmerking komend",
    status_unavailable: "Niet beschikbaar",
    success_title: "Geschiktheid succesvol gecontroleerd",
    error_title: "Check geschiktheid mislukt",
    modal_title: "Ontbrekende velden invullen",
    label_nationalId: "Nationaal ID",
    label_firstName: "Voornaam",
    label_lastName: "Achternaam",
    label_nphiesCode: "NPHIES-code verzekeraar",
    label_tpaNphiesCode: "NPHIES-code TPA",
    placeholder_nphiesCode: "Voer NPHIES-code in",
    label_policyNumber: "Polisnummer",
    label_coverageType: "Dekkingstype",
    label_membershipNumber: "Lidmaatschapsnummer",
    "auth.nameLength": "ID mag niet langer zijn dan 100 tekens",
    msg_membershipNumberLength: "Lidmaatschapsnummer mag niet langer zijn dan 100 tekens",
    label_serviceDate: "Servicedatum",
    label_birthDate: "Geboortedatum",
    label_identifierType: "Identificatietype",
    label_gender: "Geslacht",
    label_maritalStatus: "Burgerlijke staat",
    label_occupation: "Beroep",
    label_lastChecked: "Laatst gecontroleerd",
    required: "Verplicht",
    title_eligibilityResult: "Resultaat geschiktheid",
    tooltip_insurance_missing: "Geschiktheid is niet beschikbaar omdat verzekeringsgegevens ontbreken",
    hint_previewOnly: "Deze geschiktheidscontrole is alleen ter voorbeeld en wordt niet opgeslagen in het patiëntprofiel. Nadat de patiënt is aangemaakt, kunt u de geschiktheid opnieuw controleren en opslaan.",
    button_close: "Sluiten",
    label_payerName: "Naam betaler",
    label_responseDate: "Datum antwoord",
    label_payerReferenceNumber: "Referentienummer betaler",
    label_remarks: "Opmerkingen",
    label_errors: "Fouten",
    label_policyHolderName: "Naam polishouder",
    label_inceptionDate: "Ingangsdatum verzekering",
    label_expiryDate: "Vervaldatum verzekering",
    label_providerName: "Naam provider",
    label_requestDate: "Datum aanvraag",
    patient_updated_successfully: "Patiëntgegevens zijn succesvol bijgewerkt",
    error_updating_patient: "Bijwerken van patiëntgegevens is mislukt",
    "Coverage is in-force": "Dekking is van kracht",
    national_id: "Nationaal ID",
    passport: "Paspoort",
    driver_license: "Rijbewijs",
    residency: "Verblijfplaats",
    iqama: "Verblijfsvergunning (Iqama)",
    OTHER: "Overig",
    other: "Overig",
    male: "Man",
    female: "Vrouw",
    married: "Getrouwd",
    single: "Ongehuwd",
    divorced: "Gescheiden",
    separated: "Gescheiden van tafel en bed",
    widowed: "Weduwnaar/Weduwe",
    "Doctor": "Arts",
    "Dentist": "Tandarts",
    "Pharmacist": "Apotheker",
    "Engineer": "Ingenieur",
    "Accountant, Auditor": "Accountant",
    "Business Owner": "Ondernemer",
    "Military": "Militair",
    "Homemaker": "Huisman/Huisvrouw",
    "Don't Know": "Weet ik niet",
    "Not Applicable": "Niet van toepassing",
    "validation.nationalId.sa.format": "ID moet exact 10 cijfers lang zijn",
    "validation.nationalId.sa.national_id_start": "Saoedisch nationaal ID moet beginnen met 1",
    "validation.nationalId.sa.iqama_start": "Iqama / verblijfsnummer moet beginnen met 2",
    "validation.nationalId.eg.format": "Egyptisch nationaal ID moet exact 14 cijfers lang zijn",
    "validation.nationalId.eg.invalid": "Egyptisch nationaal ID heeft een ongeldige datum of eeuw",
    "visa": "Visum",
    "border_number": "Grensnummer",
    "displaced_person": "Ontheemde",
    label_nphiesCode_tooltip: "Dit is een instelling van de verzekeraar, geen patiëntgegeven. De hier ingevoerde waarde wordt alleen voor deze geschiktheidsaanvraag gebruikt en wordt niet opgeslagen bij de verzekeraar. Stel de NPHIES-code in op de verzekeraar om deze permanent te bewaren (Relaties → Verzekeraars).",
    label_policyNumber_tooltip: "Het Polisnummer uit de vastgelegde verzekeringspolis van de patiënt, verzonden met deze geschiktheidsaanvraag. Wat hier wordt ingevoerd geldt alleen voor deze aanvraag — werk het verzekeringsdossier van de patiënt bij om de opgeslagen waarde te wijzigen.",
    label_coverageType_tooltip: "Het Dekkingstype uit de vastgelegde beleidsklasse van de patiënt, verzonden met deze geschiktheidsaanvraag. Wat hier wordt ingevoerd geldt alleen voor deze aanvraag — werk het verzekeringsdossier van de patiënt bij om de opgeslagen waarde te wijzigen."
  },
  pl: {
    check_button: "Sprawdź uprawnienia",
    recheck_button: "Sprawdź ponownie",
    status_eligible: "Uprawniony",
    status_non_eligible: "Nieuprawniony",
    status_unavailable: "Niedostępny",
    success_title: "Pomyślnie sprawdzono uprawnienia",
    error_title: "Błąd sprawdzania uprawnień",
    modal_title: "Uzupełnij brakujące pola",
    label_nationalId: "Krajowy numer ID",
    label_firstName: "Imię",
    label_lastName: "Nazwisko",
    label_nphiesCode: "Kod NPHIES ubezpieczyciela",
    label_tpaNphiesCode: "Kod NPHIES TPA",
    placeholder_nphiesCode: "Wprowadź kod NPHIES",
    label_policyNumber: "Numer polisy",
    label_coverageType: "Typ zakresu",
    label_membershipNumber: "Numer członkowski",
    "auth.nameLength": "Numer identyfikacyjny nie może przekraczać 100 znaków",
    msg_membershipNumberLength: "Numer członkowski nie może przekraczać 100 znaków",
    label_serviceDate: "Data usługi",
    label_birthDate: "Data urodzenia",
    label_identifierType: "Typ identyfikatora",
    label_gender: "Płeć",
    label_maritalStatus: "Stan cywilny",
    label_occupation: "Zawód",
    label_lastChecked: "Ostatnio sprawdzono",
    required: "Wymagane",
    title_eligibilityResult: "Wynik weryfikacji",
    tooltip_insurance_missing: "Uprawnienie jest niedostępne, ponieważ brakuje informacji o ubezpieczeniu",
    hint_previewOnly: "Ta weryfikacja uprawnień służy wyłącznie do podglądu i nie zostanie zapisana w profilu pacjenta. Po utworzeniu pacjenta możesz ponownie sprawdzić uprawnienia i je zapisać.",
    button_close: "Zamknij",
    label_payerName: "Nazwa płatnika",
    label_responseDate: "Data odpowiedzi",
    label_payerReferenceNumber: "Nr referencyjny płatnika",
    label_remarks: "Uwagi",
    label_errors: "Błędy",
    label_policyHolderName: "Nazwisko posiadacza polisy",
    label_inceptionDate: "Data rozpoczęcia ubezpieczenia",
    label_expiryDate: "Data wygaśnięcia ubezpieczenia",
    label_providerName: "Nazwa świadczeniodawcy",
    label_requestDate: "Data wniosku",
    patient_updated_successfully: "Dane pacjenta zostały pomyślnie zaktualizowane",
    error_updating_patient: "Nie udało się zaktualizować danych pacjenta",
    "Coverage is in-force": "Ubezpieczenie jest ważne",
    national_id: "Krajowy ID",
    passport: "Paszport",
    driver_license: "Prawo jazdy",
    residency: "Miejsce zamieszkania",
    iqama: "Rezydencja (Iqama)",
    OTHER: "Inne",
    other: "Inne",
    male: "Mężczyzna",
    female: "Kobieta",
    married: "Żonaty/Mężatka",
    single: "Kawaler/Panna",
    divorced: "Rozwiedziony/a",
    separated: "W separacji",
    widowed: "Wdowiec/Wdowa",
    "Doctor": "Lekarz",
    "Dentist": "Stomatolog",
    "Pharmacist": "Farmaceuta",
    "Engineer": "Inżynier",
    "Accountant, Auditor": "Księgowy",
    "Business Owner": "Właściciel firmy",
    "Military": "Wojskowy",
    "Homemaker": "Gospodyni/Gospodarz domowy",
    "Don't Know": "Nie wiem",
    "Not Applicable": "Nie dotyczy",
    "validation.nationalId.sa.format": "Identyfikator musi składać się z dokładnie 10 cyfr",
    "validation.nationalId.sa.national_id_start": "Saudyjski identyfikator narodowy musi zaczynać się od 1",
    "validation.nationalId.sa.iqama_start": "Numer Iqama / rezydencji musi zaczynać się od 2",
    "validation.nationalId.eg.format": "Egipski identyfikator narodowy musi składać się z dokładnie 14 cyfr",
    "validation.nationalId.eg.invalid": "Egipski identyfikator narodowy ma nieprawidłową datę lub wiek",
    "visa": "Wiza",
    "border_number": "Numer graniczny",
    "displaced_person": "Osoba przesiedlona",
    label_nphiesCode_tooltip: "To ustawienie firmy ubezpieczeniowej, a nie dane pacjenta. Wartość wpisana tutaj jest używana wyłącznie w tym zapytaniu o uprawnienia i nie jest zapisywana w karcie ubezpieczyciela. Aby zapisać ją na stałe, ustaw kod NPHIES na firmie ubezpieczeniowej (Partnerzy → Firmy ubezpieczeniowe).",
    label_policyNumber_tooltip: "Numer polisy z zapisanej polisy ubezpieczeniowej pacjenta, wysyłany z tym zapytaniem o uprawnienia. To, co zostanie tu wpisane, dotyczy wyłącznie tego zapytania — aby zmienić zapisaną wartość, zaktualizuj dane ubezpieczenia pacjenta.",
    label_coverageType_tooltip: "Typ zakresu z zapisanej klasy polityki pacjenta, wysyłany z tym zapytaniem o uprawnienia. To, co zostanie tu wpisane, dotyczy wyłącznie tego zapytania — aby zmienić zapisaną wartość, zaktualizuj dane ubezpieczenia pacjenta."
  }
};

export const addTranslationResources = (i18next: typeof i18n) => {
  i18next.addResourceBundle("ar", "dhsCheckEligibility", resources.ar);
  i18next.addResourceBundle("en", "dhsCheckEligibility", resources.en);
  i18next.addResourceBundle("ckb", "dhsCheckEligibility", resources.ckb);
  i18next.addResourceBundle("el", "dhsCheckEligibility", resources.el);
  i18next.addResourceBundle("fr", "dhsCheckEligibility", resources.fr);
  i18next.addResourceBundle("it", "dhsCheckEligibility", resources.it);
  i18next.addResourceBundle("ku", "dhsCheckEligibility", resources.ku);
  i18next.addResourceBundle("nl", "dhsCheckEligibility", resources.nl);
  i18next.addResourceBundle("pl", "dhsCheckEligibility", resources.pl);
};
